import {
  FORM_FIELD_STATE_ID,
  FORM_FIELD_CITY_ID,
  FORM_FIELD_SERVICE_CENTRE_ID,
  FORM_FIELD_DAMAGE_DETAILS,
} from "../constants/field";
import { toObject } from "../helpers/utils";

export const fields = [
  FORM_FIELD_STATE_ID,
  FORM_FIELD_CITY_ID,
  FORM_FIELD_SERVICE_CENTRE_ID,
  FORM_FIELD_DAMAGE_DETAILS,
];

export const formFields = toObject(fields);

export const initialFormState = {
  ...formFields,
  hasError: false,
};

export const touchFieldsObject = toObject(fields, false);

export const options = {
  languages: [
    { title: "English", value: "en" },
    { title: "Hindi", value: "hindi" },
    { title: "Tamil", value: "tamil" },
  ],
};

export const timeslot = {
  start: "09:30",
  end: "17:30",
};
